export default __webpack_public_path__ + "static/media/progress-1-guest.d672a397.svg";